<template>
    <div class="menu-container" :style="containerStyle" :class="['el-'+details.id]">
        <v-style >
	        {{css}}
          {{hoverStyle}}
        </v-style>
        <ul class="menu" :style="style" :id="advanced.cssId" :class="[('menu_' + details.id), advanced.cssClasses, responsiveClasses]">
            <li v-for="(item, index) in basic.items" :key="index">
                <a :href="item.url" style="text-align: center; display: block;">
                    <span class="text_menu_item">{{item.title || 'Item ' + index}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>

import {
	borderProps,
	boxShadow,
	fontProps,
	responsiveAlignStyles,
	textShadow, getPadding
} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'EmailMenu',
    props: ['details'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
		    css() {
			    return responsiveAlignStyles(this.basic.align, this.details.id);
		    },
        hoverStyle() {
            let hover = this.basic.hoverColor ? this.basic.hoverColor : '#4368E0';
            return ( '.el-' + this.details.id + ' a:hover { color: '+ hover +';}' );
        },
	    containerStyle() {
        	return {
		        ...borderProps(this.advanced.border),
		        backgroundColor: this.advanced.backgroundColor || null,
		        boxShadow: boxShadow(this.basic.shadows),
		        margin: getPadding(this.basic.margin),
		        padding: getPadding(this.advanced.padding),
		        ...fontProps(this.basic.font),
		        textShadow: textShadow(this.advanced.textShadows),
	        }
	    },
        style() {
	        return {
		        gap: this.basic.itemsGap ? (this.basic.itemsGap.number||'0') + (this.basic.itemsGap.append||'px') : false,
	        }
        }
    },
}
</script>
